module.exports = __webpack_public_path__ + "static/media/tdsScotland.f89f75a7.png";